<template>
    <div style="position:relative;">
        <b-button-group class="d-flex">
            <b-button block id="range-datepicker-trigger" variant="light" @click="show" :disabled="disabled"
                      class="text-left font-weight-normal">
                {{datePlaceholder}}
            </b-button>
            <b-button @click="reset"
                      variant="secondary"
                      class="outline-input-special"
                      :disabled="!isSelected">
                <i class="far fa-backspace"></i>
            </b-button>
        </b-button-group>
        <slot></slot>
        <modal name="datepicker"
               :width="600"
               height="auto"
               :scrollable="true">
            <airbnb-style-datepicker
                    :trigger-element-id="'range-datepicker-trigger'"
                    :mode="'range'"
                    :fullscreen-mobile="false"
                    :date-one="range.start"
                    :date-two="range.end"
                    :inline="true"
                    @date-one-selected="function(val) { range.start = val }"
                    @date-two-selected="function(val) { range.end = val }"
                    @apply="apply"
                    @cancelled="cancelled"
            ></airbnb-style-datepicker>
        </modal>
    </div>

</template>

<script>

    function defaultData() {
        return {
            range: {
                start: null,
                end: null
            }
        }
    }

    export default {
        name: "DateRange",
        props: {
            value: null,
            disabled: false
        },
        computed: {
            isSelected() {
                return Boolean(this.$data.range.start && this.$data.range.end);
            },
            datePlaceholder() {
                if (this.isSelected) {
                    if(this.$data.range.start !== this.$data.range.end){
                        return 'от ' + this.$data.range.start + ' до ' + this.$data.range.start
                    }
                    return this.$data.range.start;
                } else {
                    return 'Выбрать период';
                }
            }
        },
        data: defaultData,
        created() {
            if (this.$props.value) {
                this.$data.range = this.$props.value
            }
        },
        methods: {
            show() {
                this.$modal.show('datepicker');
            },
            hide() {
                this.$modal.hide('datepicker');
            },
            reset() {
                Object.assign(this.$data, defaultData());
                this.$emit('input', null);
            },
            apply() {
                this.$modal.hide('datepicker');
                this.$emit('input', this.isSelected
                    ? this.$data.range
                    : null)
            },
            cancelled() {
                this.$modal.hide('datepicker');
            }
        },
        watch: {
            range(date) {
                if(!date.end && date.start) {
                    date.end = date.start;
                    this.$emit('input', this.$data.range)
                }
            }
        }
    }
</script>